import { Button, UncontrolledTooltip } from 'reactstrap';
import { useTranslation } from 'react-i18next';

export const CrmHeadingTooltip = () => {
  const { t } = useTranslation();
  return (
    <>
      {' '}
      <Button
        id={'crmInfoButton'}
        size="lg"
        color="none"
        className="position-absolute heading-tooltip border-0"
      >
        <i className="fa fa-question-circle text-muted"></i>
      </Button>
      <UncontrolledTooltip
        target={'crmInfoButton'}
        placement="bottom-start"
        container="body"
        delay={{ show: 50, hide: 50 }}
        style={{
          minWidth: '350px',
          backgroundColor: 'var(--balance-profie-bg)',
        }}
      >
        <div className="d-flex flex-column text-start">
          <p className="p-0 m-0">
            <span className="f-w-700 d-inline">{t('control.crmTable.headingTooltip.source')}</span>{' '}
            {t('control.crmTable.headingTooltip.sourceNames')}
          </p>
          <div>
            {/* <p className="p-0 m-0">
              <span className="f-w-700 d-inline">
                {t('control.crmTable.headingTooltip.reason')}{' '}
              </span>
              {t('control.crmTable.headingTooltip.reasonNames')}
            </p> */}
            <p className="p-0 mb-1 mt-2">
              {' '}
              <span className="f-w-700 d-inline">
                {' '}
                {t('control.crmTable.headingTooltip.violationDescription')}
              </span>
            </p>
            <ul className="mb-0 ps-4 d-flex flex-column gap-1" style={{ listStyle: 'initial' }}>
              <li>
                {' '}
                <span className="f-w-700 d-inline">
                  {t('control.crmTable.reason.long-deadline')}
                  {': '}
                </span>{' '}
                {t('control.crmTable.headingTooltip.violationDescriptionDetails.long-deadline')}
              </li>
              <li>
                <span className="f-w-700 d-inline">
                  {t('control.crmTable.reason.early_reject')}
                  {': '}
                </span>{' '}
                {t('control.crmTable.headingTooltip.violationDescriptionDetails.early_reject')}
              </li>
              <li>
                <span className="f-w-700 d-inline">
                  {t('control.crmTable.reason.no_comment_or_files')}
                  {': '}
                </span>{' '}
                {t(
                  'control.crmTable.headingTooltip.violationDescriptionDetails.no_comment_or_files',
                )}
              </li>
              <li>
                <span className="f-w-700 d-inline">
                  {t('control.crmTable.reason.no_questions_generated')}
                  {': '}
                </span>{' '}
                {t(
                  'control.crmTable.headingTooltip.violationDescriptionDetails.no_questions_generated',
                )}
              </li>
               <li>
                <span className="f-w-700 d-inline">
                  {t('control.crmTable.reason.overdue')}
                  {': '}
                </span>{' '}
                {t(
                  'control.crmTable.headingTooltip.violationDescriptionDetails.overdue',
                )}
              </li>
            </ul>
          </div>

          <p className="p-0 mb-0 mt-2">
            <span className="f-w-700 d-inline">{t('control.crmTable.headingTooltip.action')}</span>{' '}
            {t('control.crmTable.headingTooltip.violationDescriptionDetails.statusDescription')}
          </p>
        </div>
      </UncontrolledTooltip>
    </>
  );
};
